export default __webpack_public_path__ + "static/media/Speak.4eb55090.png";